import { render } from "./svg-download.vue?vue&type=template&id=3d6ee85e"
import script from "./svg-download.vue?vue&type=script&lang=ts"
export * from "./svg-download.vue?vue&type=script&lang=ts"
script.render = render

export default script